import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEligibleBreezeProducts } from '../../hooks/useEligibleBreezeProducts';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasPaidHubInProductInventorySelector, hasProductsInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import BreezeIntelligenceStarterPlatform from '../breeze-intelligence/BreezeIntelligenceStarterPlatform';
import LegacyBreezeTile from './LegacyBreezeTile';
import ProductTiles from './ProductTiles';
import { jsx as _jsx } from "react/jsx-runtime";
const LegacyBreezeIntelligencePackInfo = ({
  screen
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isPaid = useAppSelector(hasProductsInProductInventorySelector);
  const hasPaidHub = useAppSelector(state => hasPaidHubInProductInventorySelector(state, {}));
  const {
    eligibleBreezeApiNames,
    loading
  } = useEligibleBreezeProducts({});

  // show breeze + platform card on public or free portals or portals that don't own any core hub/bundle product
  const showPlatformCard = !isAppAuth || !isPaid || !hasPaidHub || !eligibleBreezeApiNames;
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {});
  return showPlatformCard ? /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(BreezeIntelligenceStarterPlatform, {
      screen: screen
    })
  }) : /*#__PURE__*/_jsx(ProductTiles, {
    columns: eligibleBreezeApiNames.length,
    children: eligibleBreezeApiNames.map((apiName, index) => {
      return /*#__PURE__*/_jsx(LegacyBreezeTile, {
        gridColumnStart: index + 1,
        paddingInlineStart: "700",
        paddingInlineEnd: "700",
        apiName: apiName,
        screen: screen
      }, apiName);
    })
  });
};
export default LegacyBreezeIntelligencePackInfo;